import { File, LegacyDocumentType } from '@commenda/prisma';
import { fetcher } from '@commenda/utils';

export async function upsertFile(
  body: {
    fileId?: number;
    documentType: LegacyDocumentType;
    documentName?: string;
    fileUrl: string;
    fileName: string;
    corporationId?: number;
    companyId?: number;
    serviceRequestTaskId?: number;
    transferPricingTransactionId?: string;
    formSubmissionId?: string;
    serviceRequestId?: string;
    metadata?: {
      isSigned?: boolean;
      documentName?: string;
      isPdfDownloadable?: boolean;
    };
  },
  shareToken?: string
): Promise<File | null> {
  try {
    const res = await fetcher(`file/upsert`, {
      method: 'POST',
      body,
      shareToken,
    });

    if (!res.ok) return null;
    return await res.json();
  } catch (err) {
    console.error(err);
    return null;
  }
}
